import React, { useState } from 'react';
import { ArrowUpRight, Plus } from 'lucide-react';

const FAQSection = ({
  title,
  subtitle,
  faqs: customFaqs
}) => {
  const [activeFaq, setActiveFaq] = useState(null);

  const defaultFaqs = [
    {
      question: "What is Scan to BIM?",
      answer: "Scan to BIM converts 3D laser scans (point clouds) of an existing structure into a precise BIM model using software like Revit."
    },
    {
      question: "Who uses Scan to BIM services?",
      answer: "Architects, engineers, contractors, facility managers, and residential owners use Scan to BIM for renovation projects, facility management, heritage preservation, and MEP coordination."
    },
    {
      question: "What kind of projects benefit from Scan to BIM?",
      answer: "The most benefiting projects include renovations, restorations, retrofits, commercial upgrades, residential remodeling, industrial facilities and documentation of historic buildings."
    },
    {
      question: "What software is used for Scan to BIM?",
      answer: "Our primary software is Autodesk Revit, as well as Recap, Navisworks, and other BIM coordination software."
    },
    {
      question: "Do you provide on-site talent?",
      answer: "Yes, we do on-site talent and the prices can be varied. Breathe easy, our on-site services are set to maximize cost savings and efficiency."
    },
    {
      question: "Why should we trust your service?",
      answer: "We have over 10 years of industry experience and more than 500+ satisfied clients. Our global team consists of over 90+ experienced bim modelers, architects and engineers who are carefully screened to ensure they are knowledgeable and reliable."
    },
    {
      question: "What sets your service apart from other providers?",
      answer: "Clients prefer us because of our individualistic approach. We do not offer any service provider like any other outsourcing company; our clients have access to special architects and engineers to work on the projects as part of their own company. Through direct involvement with your firm we will know your processes, standards and culture and will deliver exceeding results."
    },
    {
      question: "What if the talent isn't available during US-time hours?",
      answer: "Well, we cover the US-time hours when our talent is around. Our scan to bim modelers dedication to serving clients based in the US is part of our vetting process so that our resources are well armed to service your time zone needs."
    },
    {
      question: "What happens if the talent doesn't meet the project's expectations?",
      answer: "Should our talent not suit your project, we are ready to do something about it. We offer a 30-day money back guarantee so you can test out our service with the first month free. Also, our excellence does not just stop in the first month, we are determined to create consistent high quality results every month."
    }
  ];

  const faqs = customFaqs || defaultFaqs;

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">
          {title || <><span className="text-primary">Frequently Asked</span> Questions</>}
        </h2>
        {subtitle && <p className="faq-subtitle">{subtitle}</p>}

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeFaq === index ? 'active' : ''}`}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-question-row">
                <span className="faq-question">
                  {faq.question}
                </span>
                <span className="faq-icon">
                  <Plus size={28} strokeWidth={2.5} />
                </span>
              </div>

              <div className="faq-answer-wrapper">
                <div className="faq-answer">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <p className="faq-footer-text">Have More Questions?</p>
          <button className="faq-btn">
            Ask Our Expert <ArrowUpRight size={30} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
